import { Loader2, Truck } from "lucide-react";
import { brl, maskCep } from "./theme";

export const ShippingStep = ({ t, cep, setCep, onQuote, loading, options, service, setService, error }) => (
  <div className="space-y-3">
    <p className={t.label}>ENTREGA</p>
    <div className="flex gap-2">
      <input data-testid="checkout-cep-input" inputMode="numeric" className={t.field} placeholder="Seu CEP" value={maskCep(cep)} onChange={(e) => setCep(e.target.value)} />
      <button data-testid="checkout-quote-button" type="button" onClick={onQuote} disabled={loading || cep.replace(/\D/g, "").length !== 8} className={`shrink-0 px-5 text-sm disabled:opacity-50 ${t.btn}`}>
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Calcular"}
      </button>
    </div>
    {error && <p data-testid="checkout-quote-error" className="text-sm text-red-500">{error}</p>}
    {options.length > 0 && (
      <ul className="space-y-2" data-testid="checkout-shipping-options">
        {options.map((o) => (
          <li key={o.service_id}>
            <button type="button" data-testid={`checkout-shipping-${o.service_id}`} onClick={() => setService(o)} className={`flex w-full items-center gap-3 rounded-lg border p-3 text-left text-sm transition-colors ${service?.service_id === o.service_id ? t.sel : t.opt}`}>
              <Truck className="h-4 w-4 shrink-0" strokeWidth={1.6} />
              <span className="flex-1"><b>{o.service}</b> <span className={t.muted}>· {o.service_id === 0 ? "Santana do Livramento" : `até ${o.days} dias úteis`}</span></span>
              <b>{o.service_id === 0 ? "A combinar" : brl(o.price)}</b>
            </button>
          </li>
        ))}
      </ul>
    )}
  </div>
);
